import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWizardState } from "../hooks/useWizardState";
import { StepperControl } from "../components/forms/StepperControl";
import { Input } from "../components/ui/Form/Input";
import "./Step2Travelers.css";

export const Step2Travelers: React.FC = () => {
  const { t } = useTranslation();
  const { formData, updateFormData, errors, setFieldError } = useWizardState();
  const [showChildAges, setShowChildAges] = useState(formData.children > 0);
  const [childAges, setChildAges] = useState<number[]>(
    formData.childAges || Array(formData.children).fill(0)
  );

  useEffect(() => {
    setShowChildAges(formData.children > 0);
    if (formData.children > 0) {
      const newAges = [...childAges];
      while (newAges.length < formData.children) {
        newAges.push(0);
      }
      while (newAges.length > formData.children) {
        newAges.pop();
      }
      setChildAges(newAges);
    } else {
      setChildAges([]);
    }
  }, [formData.children]);

  useEffect(() => {
    if (formData.children > 0) {
      updateFormData({ childAges: childAges });
    } else {
      updateFormData({ childAges: [] });
    }
  }, [childAges]);

  const handleChildAgeChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const newAges = [...childAges];
    const value = e.target.value;
    newAges[index] = value === "" ? 0 : parseInt(value, 10) || 0;
    setChildAges(newAges);
    setFieldError("childAges", undefined);
  };

  return (
    <div className="step2-travelers">
      <h2 className="step-heading">{t("step2.heading")}</h2>

      <div className="form-group">
        <StepperControl
          id="adults"
          label={t("step2.adults.label")}
          value={formData.adults}
          onChange={(value) => {
            updateFormData({ adults: value });
            setFieldError("adults", undefined);
          }}
          min={1}
          required
        />
        {errors.adults && (
          <div className="field-error" role="alert">
            {errors.adults}
          </div>
        )}

        <StepperControl
          id="children"
          label={t("step2.children.label")}
          value={formData.children}
          onChange={(value) => {
            updateFormData({ children: value });
            setFieldError("children", undefined);
          }}
          min={0}
        />

        {showChildAges && (
          <div className="child-ages-container animate-slide-down">
            <h3 className="child-ages-heading">{t("step2.childrenAges.heading")}</h3>
            {childAges.map((age, index) => (
              <div key={index} className="child-age-item animate-slide-down" style={{ animationDelay: `${index * 50}ms` }}>
                <Input
                  id={`childAge-${index}`}
                  label={t("step2.childrenAges.label", { number: index + 1 })}
                  type="number"
                  value={age === 0 ? "" : age}
                  onChange={(e) => handleChildAgeChange(index, e)}
                  error={errors.childAges && index === childAges.length - 1 ? errors.childAges : undefined}
                  required
                  min="1"
                  max="17"
                  classNames={{ input: "!pl-[2.25rem]" }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

